var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quality-course-footer"},[_c('div',{staticClass:"container wrap-content"},[_c('div',{staticClass:"footer-info"},[_c('div',[_vm._v("厦门一课信息技术服务有限公司 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("闽ICP备15019684号")])])])])])
}]

export { render, staticRenderFns }